import { render, staticRenderFns } from "./CommandKItemMoreItems.vue?vue&type=template&id=7ba3e800&"
import script from "./CommandKItemMoreItems.vue?vue&type=script&lang=js&"
export * from "./CommandKItemMoreItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports